import { KYMW1503Component } from './kymw1503.component';

/**
 * マーク登録画面の値を管理するクラス
 *
 * @export KYMW1503Model
 * @class KYMW1503Model
 */
export class KYMW1503Model {

  kymw1503Component: KYMW1503Component;

  /** マークグループリスト */
  public markGroupList = [];
  public selectedMarkGroup: string = <string>'';

  /** 販売促進マークリスト */
  public supplyPromoteMarkDivList = [];
  public selectedSupplyPromoteMarkDiv: string = <string>'';

  /** 受注コード（開始）*/
  public startOrderCode: string = <string>'';
  public startOrderCodeEnabled = false;

  /** 受注コード（終了）*/
  public endOrderCode: string = <string>'';
  public endOrderCodeEnabled = false;

  /** マークコード */
  public markCode: string = <string>'';
  public markCodeEnabled = false;

  /** マーク名 */
  public markName: string = <string>'';
  public markNameDisabled = false;

  /** 使用開始　配達企画回 */
  public startDelivCatalogIdDisabled = false;

  /** 使用終了　配達企画回 */
  public endDelivCatalogIdDisabled = false;

  /** コード指定 */
  public designateCode = false;
  public designateCodeDisabled = false;

  /** 指定無し 使用開始 */
  public notDesignateStart = true;
  public notDesignateStartDisabled = false;

  /** 指定無し 使用終了 */
  public notDesignateEnd = true;
  public notDesignateEndDisabled = false;

}
